/**
 * @generated SignedSource<<68d89487833ce769c2fa09c8c96a7f5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedSellerDetails_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_viewer" | "PdpSharedSellerDetailsReviewContainer_viewer" | "PdpSharedSellerTabs_viewer">;
  readonly " $fragmentType": "PdpRespSharedSellerDetails_viewer";
};
export type PdpRespSharedSellerDetails_viewer$key = {
  readonly " $data"?: PdpRespSharedSellerDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSellerDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedSellerDetails_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_viewer"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerTabs_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerDetailsReviewContainer_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c409c628c56216fcd6458ce346444c19";

export default node;
